namespace SPA
{
	export namespace gui
	{
		export namespace view
		{
			export class AccountView extends ui.base.BaseHTMLElement
			{

				private m_Component: Wollmilch.ComponentObject;
				private m_SubmitForm: JQuery|null;

				public constructor( obj: Wollmilch.ComponentObject )
				{
					super( 'div' );

					this.m_Component = obj;
					this.m_SubmitForm = null;
				}

				public rebuild( root: JQuery|ui.base.BaseHTMLElement): AccountView
				{
					const acc = ui.$$.div();
					(root as ui.base.BaseHTMLElement).append( acc );

					if ( this.m_Component.Account )
					{
						new Wollmilch.AJAX(
							{
								url: 'account/show/' + this.m_Component.Account,
								on:
								{
									success: ( text ) =>
									{
										const obj = Wollmilch.jsonize( text );
										let lastSignIn: Date  = new Date('');
										if ( obj === null )
										{
											acc.append(
												ui.$$.h( 3, 'Der Account konnte nicht geladen werden' )
											);
											return;
										}
										const account = new Wollmilch.Account( obj.data );
										if (obj.data.LastSignIn) {
											lastSignIn = new Date(Date.parse(obj.data.LastSignIn.date));
										}

										this.buildAccountDetails(acc, account, lastSignIn);
									}
								}
							}
						).send();
					}
					else
					{
						if (this.m_Component.Type !== 'Employee') {
							return this;
						}

						this.buildCreateAccount(acc);
					}

					return this;
				}

				private buildAccountDetails(root: JQuery, account: Wollmilch.Account, lastSignIn: Date)
				{
					const form = new ui.Form.Form({
						action: 'account/changePassword/' + account.ID,
						method: 'PATCH',
						notSwitchable: true,
						submit: (method: ui.Form.FormMethod, url: string, parameter: ui.Form.IFormParameter) => {
							$('.btn-ajax').trigger('account');
							this.m_SubmitForm = form.Root();
							this.onUpdateAccount(method, url, parameter);
						},
						autocomplete: "off",
					});

					const password = new ui.Form.TextInput('', {
						name: 'password.current',
						attr: {type: 'password', minlength: "5"},
						control: true,
						required: true,
					});
					password.Initialize();

					const passwordNew = new ui.Form.TextInput('', {
						name: 'password.new',
						attr: {type: 'password', minlength: "5"},
						control: true,
						placeholder: 'Neues Kennwort',
						required: true,
					});
					passwordNew.Initialize();

					const passwordConfirm = new ui.Form.TextInput('', {
						name: 'password.confirm',
						attr: {type: 'password', minlength: "5"},
						control: true,
						required: true,
						placeholder: 'Kennwort wiederholen',
						on: {
							keyup: (e) => {
								const thisVal = $(e[0][0].currentTarget).val();
								const inputMatch: boolean = thisVal === passwordNew.val();

								$(e[0][0].currentTarget).closest('.form-group')
									.toggleClass('has-error', !inputMatch);
							}
						}
					});
					passwordConfirm.Initialize();

					form.Input([
						new ui.Form.NumberInput(app.getAuthenticationManager().getCompany().ID, {name: 'company'}),
						new ui.Form.NumberInput(this.m_Component.ID, {name: 'componentID'}),
						password, passwordNew, passwordConfirm]);
					form.Initialize();

					const submitButton = ui.$$.button().addClass('btn btn-success btn-ajax')
						.attr({
							type: 'submit'
						}).append('<i class="fa fa-save"></i> <span>Passwort aktualisieren</span>');
					root
						.append(ui.$$.h(2, 'Account-Daten'))
						.append(form.Root()
							.append(ui.$$.div().addClass('row')
								.append(ui.$$.div().addClass('col-xs-10 col-sm-4 col-md-3')
									.append(ui.$$.div().addClass('form-group')
										.append('<label class="control-label">Ihr Benutzername</label>')
										.append(`<div>${account.Username}</div>`)
									)
								)
								.append(ui.$$.div().addClass('col-xs-10 col-sm-4 col-md-3')
									.append(ui.$$.div().addClass('form-group')
										.append('<label class="control-label">Letzter Login</label>')
										.append('<div>' + (!isNaN(lastSignIn as unknown as number) ?
											('0' + lastSignIn.getDate()).slice(-2) + "/" +
											('0' + (lastSignIn.getMonth() + 1)).slice(-2)  + "/" +
											lastSignIn.getFullYear() + ", " +
											('0' + lastSignIn.getHours()).slice(-2) + ":" +
											('0' + lastSignIn.getMinutes()).slice(-2) + " Uhr"
											: 'Bisher kein Login') + '</div>')
									)
								)
							)
							.append(ui.$$.div().addClass('row')
								.append(ui.$$.div().addClass('col-xs-12')
									.append('<h3>Passwort ändern</h3>')
								)
								.append(ui.$$.div().addClass('col-xs-12 col-sm-6 col-md-4')
									.append(ui.$$.div().addClass('form-group')
										.append('<label class="control-label">Aktuelles Passwort</label>')
										.append(password.Input())
									)
								)
							)
							.append(ui.$$.div().addClass('row')
								.append(ui.$$.div().addClass('col-xs-12 col-sm-6 col-md-4')
									.append(ui.$$.div().addClass('form-group')
										.append('<label class="control-label">Neues Passwort</label>')
										.append(passwordNew.Input())
									)
								)
								.append(ui.$$.div().addClass('col-xs-12 col-sm-6 col-md-4')
									.append(ui.$$.div().addClass('form-group')
										.append('<label class="control-label">Neues Passwort wiederholen</label>')
										.append(passwordConfirm.Input())
									)
								)
							)
							.append(ui.$$.div().addClass('row')
								.append(ui.$$.div().addClass('col-xs-12')
									.append($('<p>Geänderte Zugangsdaten sind nach dem Speichern sofort aktiv.<br>Dies betrifft auch den Login in der App.</p>'))
								)
							)
							.append(ui.$$.div().addClass('row')
								.append(ui.$$.div().addClass('col-xs-6')
									.append(ui.$$.div().addClass('alert ajax-response').hide())
									.append(submitButton)
								)
							)
						);
				}

				private onUpdateAccount(method: ui.Form.FormMethod, url: string, parameter: ui.Form.IFormParameter)
				{
					new Wollmilch.AJAX({
						method,
						url,
						data: parameter,
						on: {
							success: (text: string): void => {
								const response = JSON.parse(text);
								const button = $('.btn-ajax');

								(this.m_SubmitForm as JQuery).find('.ajax-response').show()
									.removeClass('alert-success alert-danger')
									.addClass(response.success ? 'alert-success' : 'alert-danger')
									.text(response.message);

								button.empty().append('<i class="fa fa-save"></i> <span>Passwort aktualisieren</span>');
								if (response.success) {
									$('.ajax-response').delay(5000)
										.slideUp('slow');

									// Clear form inputs
									(this.m_SubmitForm as JQuery).find('input').val('');
								}
							}
						}
					}, AJAXCallbase_e.APIV1).send();
				}

				private buildCreateAccount(root: JQuery)
				{
					const form = new ui.Form.Form({
						action: 'account/new',
						notSwitchable: true,
						method: 'POST',
						submit: (method: ui.Form.FormMethod, url: string, parameter: ui.Form.IFormParameter) => {
							$('.btn-ajax').trigger('account');
							this.m_SubmitForm = form.Root();
							this.onCreateAccount(method, url, parameter);
						},
						autocomplete: "off",
					}).addClass('accountforms');

					const email1 = new ui.Form.TextInput('', {
						name: 'email',
						required: true,
					});
					email1.Initialize();
					const email2 = new ui.Form.TextInput('', {
						name: 'email_confirm',
						required: true,
						on: {
							keyup: (e) => {
								const thisVal = $(e[0][0].currentTarget).val();
								const inputMatch: boolean = thisVal === email1.val();

								$(e[0][0].currentTarget).closest('.form-group')
									.toggleClass('has-error', !inputMatch);
							}
						},
					});
					email2.Initialize();

					const password1 = new ui.Form.TextInput('', {
						name: 'password',
						attr: {type: 'password', minlength: "5"},
						control: true,
						required: true,
					});
					password1.Initialize();
					const password2 = new ui.Form.TextInput('', {
						control: true,
						attr: {type: 'password', minlength: "5"},
						name: 'password_confirm',
						required: true,
						on: {
							keyup: (e) => {
								const thisVal = $(e[0][0].currentTarget).val();
								const inputMatch: boolean = thisVal === password1.val();

								$(e[0][0].currentTarget).closest('.form-group')
									.toggleClass('has-error', !inputMatch);
							}
						}
					});
					password2.Initialize();

					const submitButton = ui.$$.button().addClass('btn btn-success btn-ajax')
						.attr({
							'type': 'submit',
							'id': 'count',
							'data-progress': 'Account wird verarbeitet...'
						})
						.text('Account anlegen & aktivieren');

					form.Input([
						new ui.Form.NumberInput(app.getAuthenticationManager().getCompany().ID, {name: 'company'}),
						new ui.Form.NumberInput(this.m_Component.ID, {name: 'componentID'}),
						email1, email2, password1, password2]);
					form.Initialize();

					root
						.append(ui.$$.p().text('Erstellen Sie hier einen Login für Ihren Mitarbeiter.'))
						.append(form.Root()
							.append(ui.$$.div().addClass('row')
								.append(ui.$$.div().addClass('col-xs-10 col-sm-6 col-md-4')
									.append(ui.$$.div().addClass('form-group')
										.append('<label class="control-label">Benutzername</label>')
										.append(email1.Root())
									)
								)
								.append(ui.$$.div().addClass('col-xs-10 col-sm-6 col-md-4')
									.append(ui.$$.div().addClass('form-group')
										.append('<label class="control-label">Benutzername wiederholen</label>')
										.append(email2.Root())
									)
								)
							)
							.append(ui.$$.div().addClass('row')
								.append(ui.$$.div().addClass('col-xs-10 col-sm-6 col-md-4')
									.append(ui.$$.div().addClass('form-group')
										.append('<label class="control-label">Passwort vergeben</label>')
										.append(password1.Root())
									)
								)
								.append(ui.$$.div().addClass('col-xs-10 col-sm-6 col-md-4')
									.append(ui.$$.div().addClass('form-group')
										.append('<label class="control-label">Passwort wiederholen</label>')
										.append(password2.Root())
									)
								)
							)
							.append(ui.$$.div().addClass('row')
								.append(ui.$$.div().addClass('col-xs-4')
									.append(ui.$$.div().addClass('alert ajax-response').hide())
									.append(submitButton)
								)
							)
						);
				}

				private onCreateAccount(method: ui.Form.FormMethod, url: string, parameter: ui.Form.IFormParameter)
				{
					new Wollmilch.AJAX({
						method,
						url,
						data: parameter,
						on: {
							success: (text: string): void => {
								const response = JSON.parse(text);
								const button = $('.btn-ajax');

								if (!response.success)
								{
									button.empty().text('Account anlegen & aktivieren');
									return;
								}

								button.hide();
								app.addNotify(
									{
										context: "success",
										body: ['Der Account für ' + this.m_Component.Name + ' wurde angelegt.'],
										timeout: 6000,
										title: ['Account angelegt']
									}
								);
								$('html').trigger('reloadOrgaTree');
								$('html').trigger('accountCreated', [{employee: this.m_Component.ID}]);
							}
						}
					}, AJAXCallbase_e.APIV1).send();
				}
			}
		}
	}
}
